import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
/** @Account */
import Login from '@/views/Account/Login.vue';
import Signup from '@/views/Account/Signup.vue';
import SignupPassword from '@/views/Account/SignupPassword.vue';

/** @About */
import About from '@/views/About/index.vue';

/** @Support */
import Shien from '@/views/Shien/index.vue';

/** @Interview */
import Interview from '@/views/Interview/index.vue';
import InterviewDetail from '@/views/Interview/[open_id].vue';

/** @Event */
import Event from '@/views/Event/index.vue';
import EventDetail from '@/views/Event/[open_id].vue';

/** @Recruit */
import Hataraku from '@/views/Recruit/index.vue';
import HatarakuDetail from '@/views/Recruit/[open_id].vue';

/** @Topics */
import Topics from '@/views/Topics/index.vue';
import TopicsDetail from '@/views/Topics/[slug].vue';

/** @News */
import News from '@/views/News/index.vue';

/** @Pages */
import Contact from '@/views/Pages/Contact.vue';

/** @Error */
import NotFound from '@/views/Error/NotFound.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'top',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    children: [
      {
        path: '/signup/password',
        name: 'signup/password',
        component: SignupPassword,
      },
    ],
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      name: 'about',
      title: '産地を知る',
      description: '桐生市の織物・繊維産地の基本情報、特長・魅力、メディア発信についてまとめました。',
      headColor: 'purple',
      showDetailHead: true,
      showMenu: true,
    },
  },
  {
    path: '/shien',
    name: 'Shien',
    component: Shien,
    meta: {
      title: '支援・サポート体制',
      name: 'shien',
      description: '織物・繊維産地に携わるコーディネーター陣が、あなたの相談内容に応じた就労・開業支援を行います。',
      headColor: 'green',
      showDetailHead: true,
      showMenu: true,
    },
  },
  {
    path: '/topics',
    name: 'Topics',
    component: Topics,
    meta: {
      title: '産地トピックス',
      name: 'topics',
      description: '産地の最新トピックスをお届けします。',
      headColor: 'blue',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/topics/:slug',
    name: 'TopicsDetail',
    component: TopicsDetail,
    meta: {
      title: '産地トピックス',
      name: 'topics',
      description: '産地の最新トピックスをお届けします。',
      headColor: 'blue',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/interview',
    name: 'Interview',
    component: Interview,
    meta: {
      title: '産地インタビュー',
      name: 'interview',
      description: '1,300年続く織物・繊維産地で働き・関わる様々な方の声をお届けします。',
      headColor: 'pink',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/interview/:open_id',
    name: 'InterviewDetail',
    component: InterviewDetail,
    meta: {
      title: '産地インタビュー',
      name: 'interview',
      description: '1,300年続く織物・繊維産地で働き・関わる様々な方の声をお届けします。',
      headColor: 'pink',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/event',
    name: 'Event',
    component: Event,
    meta: {
      title: '産地イベント',
      name: 'event',
      description: '産地で行われているイベント情報をお届けします。',
      headColor: 'pink',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/event/:open_id',
    name: 'EventDetail',
    component: EventDetail,
    meta: {
      title: '産地イベント',
      name: 'event',
      description: '産地で行われているイベント情報をお届けします。',
      headColor: 'pink',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/hataraku',
    name: 'Hataraku',
    component: Hataraku,
    meta: {
      title: '産地で働く',
      name: 'hataraku',
      description: '産地の事業者情報をお届けします',
      headColor: 'pink',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/hataraku/:open_id',
    name: 'HatarakuDetail',
    component: HatarakuDetail,
    meta: {
      title: '産地で働く',
      name: 'hataraku',
      description: '産地の事業者情報をお届けします',
      headColor: 'pink',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: 'お知らせ',
      name: 'news',
      description: 'むすびすむ桐生のお知らせ情報をお届けします。',
      headColor: 'blue',
      showDetailHead: true,
      showMenu: false,
    },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'お問い合わせ',
      name: 'contact',
      description: '産地での就労・開業に関するお問い合わせをWebフォームで受け付けています。\n下記、必要事項をご入力のうえ送信ください。\nコーディネーターが内容を確認後、ご連絡させていただきます。',
      headColor: 'blue',
      showDetailHead: true,
      showMenu: false,
    },
  },
  /** @Error */
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'Not Found',
      description: 'お探しのページは見つかりませんでした',
      name: 'contact',
      headColor: 'blue',
      showDetailHead: true,
      showMenu: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  // ページ遷移時
  scrollBehavior(to, from, savedPosition) {
    let position = {};
    // fromとtoの違いがない場合はスルー
    if (from.path && to.path === from.path) return;
    if (!to.hash) {
      // ハッシュがなく、
      if (savedPosition) { // ブラウザバック
        position = { top: savedPosition.top };
      } else { // ページ遷移
        position = { top: 0, scrollBehavior: 'auto' };
      }
    }
    // else {
    //   // ハッシュが存在する場合スクロール
    //   position = { selector: to.hash };
    // }
    return position;
  },
});

// Meta Pixel 管理
const META_PIXEL_ID = '841937378875536';

const META_PIXEL_ROUTES = [
  { path: '/contact', trackEvent: 'CompleteRegistration' },
  { path: '/event/LOCAL_TALK_CityLabTOKYO', trackEvent: null },
  { path: '/event/GROWCATION2025_sakagura', trackEvent: null },
];

const injectMetaPixel = () => {
  if (document.getElementById('meta-pixel-script')) return;
  const script = document.createElement('script');
  script.id = 'meta-pixel-script';
  // eslint-disable-next-line prefer-template
  script.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${META_PIXEL_ID}');fbq('track','PageView');`;
  document.head.appendChild(script);
  const noscript = document.createElement('noscript');
  noscript.id = 'meta-pixel-noscript';
  noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id='${META_PIXEL_ID}&ev=PageView&noscript=1"/>`;
  document.head.appendChild(noscript);
};

const removeMetaPixel = () => {
  ['meta-pixel-script', 'meta-pixel-noscript'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.remove();
  });
  delete window.fbq;
  delete window._fbq;
};

router.afterEach((to) => {
  const normalizedPath = to.path.replace(/\/$/, '');
  const matchedRoute = META_PIXEL_ROUTES.find((route) => route.path === normalizedPath);
  if (matchedRoute) {
    injectMetaPixel();
    if (matchedRoute.trackEvent) {
      window.fbq('track', matchedRoute.trackEvent);
    }
  } else {
    removeMetaPixel();
  }
});

export default router;
